import { render, staticRenderFns } from "./PpeInventoryEdit.vue?vue&type=template&id=0fa80900&"
import script from "./PpeInventoryEdit.vue?vue&type=script&lang=js&"
export * from "./PpeInventoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports